module.exports = "https://cdn.hellotech.com/client-assets/HT_techKatie_4507aa5cb836dbbb576f9102c3e1b5ef.jpg";